export default __webpack_public_path__ + "static/media/yellowInfo.2cce2928.svg";